export default __webpack_public_path__ + "static/media/gallery-crosssells3.8645b2e5.png";